var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgArrowGoForward10 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4973 14.3455V23H12.9296V15.871H12.8788L10.8547 17.1641V15.7273L13.0056 14.3455H14.4973Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8228 23.1648C18.1269 23.1648 17.5296 22.9887 17.031 22.6366C16.5352 22.2816 16.1534 21.7703 15.8858 21.1026C15.621 20.4321 15.4886 19.625 15.4886 18.6812C15.4914 17.7374 15.6252 16.9345 15.89 16.2724C16.1577 15.6076 16.5394 15.1005 17.0352 14.7511C17.5339 14.4018 18.1297 14.2271 18.8228 14.2271C19.5158 14.2271 20.1116 14.4018 20.6103 14.7511C21.1089 15.1005 21.4907 15.6076 21.7555 16.2724C22.0231 16.9373 22.157 17.7402 22.157 18.6812C22.157 19.6278 22.0231 20.4363 21.7555 21.1068C21.4907 21.7745 21.1089 22.2844 20.6103 22.6366C20.1145 22.9887 19.5186 23.1648 18.8228 23.1648ZM18.8228 21.8421C19.3637 21.8421 19.7905 21.5759 20.1032 21.0434C20.4187 20.5082 20.5765 19.7207 20.5765 18.6812C20.5765 17.9938 20.5047 17.4162 20.361 16.9486C20.2173 16.4809 20.0145 16.1288 19.7524 15.8921C19.4904 15.6527 19.1805 15.5329 18.8228 15.5329C18.2847 15.5329 17.8593 15.8006 17.5466 16.3358C17.2338 16.8683 17.0761 17.6501 17.0733 18.6812C17.0704 19.3714 17.1395 19.9518 17.2803 20.4222C17.424 20.8927 17.6268 21.2477 17.8888 21.4871C18.1509 21.7238 18.4622 21.8421 18.8228 21.8421Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11 7H16V11L22 6L16 1V5H11C8.87827 5 6.84344 5.84285 5.34315 7.34315C3.84285 8.84344 3 10.8783 3 13C3 15.1217 3.84285 17.1566 5.34315 18.6569C6.60577 19.9195 8.247 20.7165 10 20.9373V18.9161C8.77969 18.7098 7.64405 18.1293 6.75736 17.2426C5.63214 16.1174 5 14.5913 5 13C5 11.4087 5.63214 9.88258 6.75736 8.75736C7.88258 7.63214 9.4087 7 11 7Z"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowGoForward10);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow-go-forward-10.2b851d5ce70c94efa2c3e9973c573939.svg";